import React from 'react';
import { Link } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import '../components/Loader.css';
import CategoriesIndexView from './CategoriesIndexView';
import useCategories from '../data/useCategories';
import { GOLD_LT, CREAM, INK } from '../theme';

function Notice({ title, linkTo, linkLabel }) {
  return (
    <div style={{ fontFamily: "'Cormorant Garamond', serif", background: INK, color: '#efe4d2', minHeight: '100vh' }}>
      <Nav />
      <main id="ij-main">
      <section style={{ padding: 'clamp(100px,16vh,180px) clamp(20px,4vw,60px)', textAlign: 'center' }}>
        <h1 style={{ fontFamily: "'Bodoni Moda', serif", fontStyle: 'italic', fontWeight: 500, fontSize: 'clamp(32px,4.4vw,48px)', color: CREAM, margin: '0 0 20px' }}>{title}</h1>
        <Link to={linkTo} style={{ color: GOLD_LT, textDecoration: 'none', fontSize: 16 }}>{linkLabel}</Link>
      </section>
      </main>
      <Footer />
    </div>
  );
}

export default function CategoriesIndex() {
  const { categories, loading, error } = useCategories();

  if (loading) {
    return (
      <div style={{ fontFamily: "'Cormorant Garamond', serif", background: INK, color: '#efe4d2', minHeight: '100vh' }}>
        <Nav />
      <main id="ij-main">
        <section
          aria-busy="true"
          aria-live="polite"
          style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 18, minHeight: 'calc(var(--vh, 1vh) * 70)', padding: 'clamp(60px,10vh,120px) clamp(20px,4vw,60px)' }}
        >
          <div className="ij-loader-wrap" style={{ position: 'static' }}><span className="ij-loader" /></div>
          <p style={{ fontSize: 15, letterSpacing: '.16em', textTransform: 'uppercase', color: 'rgba(239,228,210,.45)', margin: 0 }}>Loading</p>
        </section>
        </main>
      <Footer />
      </div>
    );
  }

  if (error) {
    return <Notice title="Categories are temporarily unavailable" linkTo="/" linkLabel="← Back home" />;
  }

  return (
    <div style={{ fontFamily: "'Cormorant Garamond', serif", background: INK, color: '#efe4d2', minHeight: '100vh' }}>
      <Nav />
      <main id="ij-main">
      <CategoriesIndexView categories={categories} />
      </main>
      <Footer />
    </div>
  );
}
